import React from 'react';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import PageContent from '../components/PageContent';
import PageTitle from '../components/PageTitle';
import FollowUpAppFooter from '../components/FollowUpAppFooter';
import { StyledWrapper } from '../components/PageLayout';

const FollowUpContactPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('pages.followup.contact.pageTitle')} />
      <StyledWrapper $withStickyFooter={false}>
        <PageContent>
          <Text tagName="h1" textStyle="Heading.L">
            {t('pages.followup.contact.title')}
          </Text>
          {/* TODO: Mount the shared contact form and apply paid-service additional-recipient rules. */}
          <FollowUpAppFooter prevVisible nextVisible />
        </PageContent>
      </StyledWrapper>
    </>
  );
};

export default FollowUpContactPage;
